import { useEffect, useState } from 'react';
import { UserApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { Evaluation } from '../../../commonTypes/evaluation/calculate.types';

const useHttpGetEvaluationOnMount = (id: string, isUpdateRequested?: boolean) => {
    const userApi: UserApi = useContainer(UserApi);
    const [data, setData] = useState<Evaluation>();
    const [isReady, setIsReady] = useState<boolean>();

    const { exec, abort } = userApi.getEvaluationById({
        params: { id },
        onSuccess: res => setData(res.body),
        onFinally: () => setIsReady(true),
    });

    useEffect(() => {
        setIsReady(false);
        exec();
        return abort;
    }, [id, isUpdateRequested]);

    return { data, isReady };
};

export default useHttpGetEvaluationOnMount;
